import React, { useState } from "react"
import { useSelector } from "react-redux"

import { StoreType } from "client/store"
import {
    PageContent,
    PageMenu,
    PageMenuButton,
    Tab,
} from "client/components"

import List from "./list"
import { ContainerStyled, Title } from "../styled"

const CcResponse = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const menu = [
        { key: "#responsible", module: 0, title: lang.responsible },
        { key: "#compliance", module: 1, title: lang.compliance },
        { key: "#reviewCompliance", module: 2, title: lang.reviewCompliance },
        { key: "#reviewReview", module: 3, title: lang.reviewReview },
        { key: "#requirements", module: 4, title: lang.requirements },
    ]

    const [activeTab, setActiveTab] = useState("#responsible")

    return (
        <ContainerStyled>
            <Title>{lang.responses}</Title>
            <PageContent>
                <PageMenu>
                    {
                        menu.map((menuRow) => (
                            <PageMenuButton
                                key={menuRow.key}
                                isActive={activeTab === menuRow.key}
                                onClick={() => setActiveTab(menuRow.key)}
                            >
                                {menuRow.title}
                            </PageMenuButton>
                        ))
                    }
                </PageMenu>
                {
                    menu.map((menuRow) => (
                        <Tab
                            key={menuRow.key}
                            show={activeTab === menuRow.key}
                        >
                            <List module={menuRow.module} />
                        </Tab>
                    ))
                }
            </PageContent>
        </ContainerStyled>
    )
}
export default CcResponse
